<template>
    <cmp-contact-link-list class="footer-contact-box"
            facet="contact"
            :entries="content.links">
    </cmp-contact-link-list>
</template>

<script>
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [cmsPlugin],
    };
</script>



// WEBPACK FOOTER //
// index.vue?cbc29a00